import { Component, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/core/common-services/notification.service';
import { UserDataService } from 'src/app/core/data-services/identity/user.data.service';
import { JariValidators } from 'src/app/shared/shared/jari-validators';
import { DialogService } from 'src/app/shared/services/dialog.service';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent {
  oldPassword!: string;
  newPassword!: string;
  confirmNewPassword!: string;
  validPasswordPattern = JariValidators.validPasswordRegex;
  hideOldPassword: boolean = false;
  hideNewPassword: boolean = false;
  hideConfirmNPassword: boolean = false;
  @ViewChild('successDialogRef') successDialogRef!: TemplateRef<any>;


  constructor(
    private userDataService: UserDataService,
    private notificationServie: NotificationService,
    private router: Router,
    private matDialog:MatDialog,
    private dialogService: DialogService,
  ) { }

  isPasswordIdentical() {
    return this.newPassword && this.confirmNewPassword && this.newPassword.replaceAll(' ', '') == this.confirmNewPassword.replaceAll(' ', '');
  }
  changePassword(){
    this.userDataService.ChangePassword(this.oldPassword!,this.newPassword,this.confirmNewPassword).subscribe({
      next:(res)=>{
        this.notificationServie.success(res.data.message);
        this.showSuccessDialog();

      },
      error:(error)=>{
        this.notificationServie.error(error?.error?.message)
      }
    })
  }
 closeDialog(){
  this.matDialog.closeAll();
 }
  showSuccessDialog(){
    this.closeDialog();
    this.dialogService.open(this.successDialogRef,{
      width: '600px',
    });
  }
}
